// ============================================================
// NETWORK CONFIGURATION
// ------------------------------------------------------------
// Change ACTIVE_NETWORK to switch between environments.
// Users never see this — it's purely for code-side control.
// Values: 'mainnet' | 'testnet'
// ============================================================

export const ACTIVE_NETWORK = 'mainnet';

export const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    name: 'BNB Smart Chain',
    displayName: 'BNB Chain',
    rpcUrls: [
      'https://bsc-dataseed.binance.org/',
      'https://bsc-dataseed1.defibit.io/',
      'https://bsc-dataseed1.ninicoin.io/'
    ],
    blockExplorerUrl: 'https://bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    usdtAddress: '0x55d398326f99059fF775485246999027B3197955',
    usdtDecimals: 18
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    name: 'BNB Smart Chain',
    displayName: 'BNB Chain',
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.binance.org:8545/',
      'https://data-seed-prebsc-2-s1.binance.org:8545/'
    ],
    blockExplorerUrl: 'https://testnet.bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    usdtAddress: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC',
    usdtDecimals: 18
  }
};

export const CURRENT_NETWORK = NETWORKS[ACTIVE_NETWORK];

export const getNetworkConfig = () => CURRENT_NETWORK;
